export function getRichTextContentElement(contentEditableOnly = true) {
  return contentEditableOnly
    ? document.querySelectorAll('.public-DraftEditor-content[contenteditable=true]')
    : document.querySelectorAll('.public-DraftEditor-content')
}

export function getActiveRichTextContentElementIndex(richTextContents = getRichTextContentElement()) {
  for (let i = 0; i < richTextContents.length; i++) {
    const richTextContent = richTextContents.item(i)
    if (richTextContent && richTextContent.contains(document.activeElement)) {
      return i
    }
  }
  return -1
}

export function getPreviousRichTextContentElement(richTextContents = getRichTextContentElement()) {
  const activeRichTextContentIndex = getActiveRichTextContentElementIndex(richTextContents)
  return 0 < activeRichTextContentIndex ? richTextContents.item(activeRichTextContentIndex - 1) : null
}

export function getNextRichTextContentElement(richTextContents = getRichTextContentElement()) {
  const activeRichTextContentIndex = getActiveRichTextContentElementIndex(richTextContents)
  return -1 < activeRichTextContentIndex ? richTextContents.item(activeRichTextContentIndex + 1) : null
}
